// extracted by mini-css-extract-plugin
export default {"FailedAddonsActionsMessage__borderColor":"FailedAddonsActionsMessage_FailedAddonsActionsMessage__borderColor__GS5sA"};